<template>
  <!--  <el-scrollbar style="height: 100vh">&lt;!&ndash;全局滚动条 但是作为容器 隐藏会连累子元素 而且el-backtop就无效了 捨てて 不如自己写css&ndash;&gt;-->
  <el-avatar :src="require('./assets/干得漂亮.jpg')" shape="circle"
             style="width: 100px;height:100px;margin: 10px;cursor: pointer"
             @click="isShowMedia && (dialogVisible = true)"/>
  <!--短路求值-->
  <br>
  <el-tooltip effect="customized" :content="'—— ' + hitokoto.from" placement="bottom" :offset="-12" :show-arrow="false">
    <el-link href="https://developer.hitokoto.cn/" target="_blank" :underline="false" style="max-width: 90%">
      <h2>
        <span style="color: #999999">hitokoto:&nbsp;</span>
        <span>{{ hitokoto.sentence }}</span>
      </h2>
    </el-link>
  </el-tooltip>
  <template v-if="isShowMedia">
    <el-dialog v-model="dialogVisible">
      <el-upload :action="uploadURL" drag multiple accept="video/mp4,image/jpeg,image/png,image/gif,image/bmp"
                 name="file" :on-success="uploadSuccess" :before-upload="beforeUpload">
        <el-icon class="el-icon--upload">
          <upload-filled/>
        </el-icon><!--这个多文件实际上是多次调用单文件上传接口-->
        <div>将文件拖到此处，或<em>点击上传</em></div>
        <template #tip>
          <p>上传.mp4格式视频(&le;200MB) or .jpg .png</p>
        </template>
      </el-upload>
    </el-dialog>
    <el-switch
        v-model="isSingleMode"
        size="large"
        :active-icon="PictureFilled"
        :inactive-icon="Menu"
        inline-prompt
        style="position: fixed;top: 8px;left: 8px;z-index: 2"
    />
    <template v-if="isSingleMode">
      <Viewer style="padding-bottom: 0"/>
    </template>
    <template v-else>
      <MultiViewer style="margin-top: 20px"/>
    </template>
    <span id="footer" style="color: #c2c5c5;padding-bottom: 4px;text-align: center">  cls ❤ Darli</span>
  </template>
  <template v-else>
    <br>
    <p class="countDown">
      {{ gap }}s
    </p>
  </template>
  <!--  </el-scrollbar>-->
</template>

<script>
import Viewer from './components/Viewer.vue'
import axiosIns from "@/utils/axiosInstance";
import {ElNotification} from "element-plus";
import * as imageConversion from "image-conversion";
import MultiViewer from "@/components/MultiViewer.vue";
import {Menu, PictureFilled} from "@element-plus/icons-vue";
import {markRaw} from "vue";

export default {
  name: 'App',
  components: {
    MultiViewer,
    Viewer
  },
  inject: [
    'baseUrl'
  ],
  data() {
    return {
      isShowMedia: false,
      timer: '',
      gap: '?',
      dialogVisible: false,
      uploadURL: this.baseUrl + '/upload',
      isSingleMode: false, //单图模式
      Menu: markRaw(Menu), //不需要代理 提升性能
      PictureFilled: markRaw(PictureFilled),
      hitokoto: {
        sentence: 'NULL',
        from: 'NULL'
      }
    }
  },
  methods: {
    updateTime() {
      // this.gap = Math.floor((Date.parse("2023-01-15 12:00") - Date.now()) / 1000);
      this.gap--
      if (this.gap < 0) {
        clearInterval(this.timer)
        ElNotification({
          title: 'お誕生日おめでとう',
          message: "阳阳生日快乐~",
        })
        setTimeout(() => {
          ElNotification({
            title: 'お誕生日おめでとう',
            message: "阳阳生日快乐~",
            position: 'bottom-right'
          })
        }, 500)
        setTimeout(() => {
          ElNotification({
            title: 'お誕生日おめでとう',
            message: "阳阳生日快乐~",
            position: 'bottom-left'
          })
        }, 1000)
        setTimeout(() => {
          ElNotification({
            title: 'お誕生日おめでとう',
            message: "阳阳生日快乐~",
            position: 'top-left'
          })
        }, 1500)
        setTimeout(() => {
          this.isShowMedia = true
        }, 2000)
        // this.isShowVideo = true
      }
    },
    uploadSuccess(res) {
      console.log(res)
    },
    beforeUpload(file) {
      console.log(file.type)
      if (file.type.startsWith('image') && file.type !== 'image/gif') { //图片压缩
        return new Promise((resolve) => {
          /*let sW = 1920 / file.width //undefined
          let sH = 1080 / file.height
          console.log(file.width, file.height, sW, sH, Math.min(sW, sH, 1))*/
          // 压缩到200KB
          imageConversion.compressAccurately(file, 200).then(res => { //TODO 200KB 不合理
            console.log(res)
            resolve(res) //resolve函数返回真实值
          })
        })
      }
    },
    getSentence() {
      axiosIns.get("https://v1.hitokoto.cn").then(res => {
        this.hitokoto.sentence = res.data["hitokoto"]
        this.hitokoto.from = res.data["from"]
        console.log(res.data)
      })
    }
  },
  created() {
    this.getSentence()
    axiosIns.get("/getVideoList").then(res => {
      if (res.data["state"]) {
        this.isShowMedia = true
      } else {
        this.gap = res.data["waitSecond"]
        this.timer = setInterval(this.updateTime, 1000)
      }
    }).catch(res => {
      console.log(res)
      this.gap = "ERROR: server down"
    })
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  background-image: url("@/assets/room.jpg");
  background-attachment: fixed; /*固定背景图片*/
}

html, body {
  min-height: 100%;
  /*width: 100%;*/
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #E5EAF3;
  /*position: relative;*/
  height: 100%;
}

.countDown {
  font-size: 72pt;
  font-family: Consolas;
  color: #242526;
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -40%);
  background-color: rgba(200, 200, 200, 0.5);
  border-radius: 10px;
  padding: 10px;
}

::-webkit-scrollbar { /*删除滚动条*/
  width: 0;
  height: 0;
}
</style>

<style>
/*tooltip*/
.el-popper.is-customized {
  background-color: rgba(36, 37, 38, 0.47);
}
</style>
